export function resolveRedirectRoute (path, id, event) {
  const eventIdentifier = `${event.name.toLowerCase()}${event.edition.substring(2)}`
  const baseParams = {
    event: eventIdentifier
  }

  switch (path) {
    case 'home':
    case 'club':
    case 'uniforms':
    case 'club-payments':
      return {
        name: path,
        params: baseParams
      }

    case 'team':
      return {
        name: path,
        params: {
          ...baseParams,
          id: id
        }
      }

    case 'players':
    case 'staff':
    case 'acompanyants':
    case 'travels':
    case 'insurances':
    case 'finals':
    case 'finals_saturday':
    case 'opening':
    case 'credentials':
    case 'image-rights':
    case 'payments':
    case 'hotels':
    case 'sanctions':
    case 'matches':
      return {
        name: path,
        params: {
          ...baseParams,
          team_id: id
        }
      }

    default:
      return null
  }
}
